import React from 'react'
import classNames from 'classnames'

function UtilityBar({ children, modifierClasses = [], handleClick, showUtilityBar, setUtilityBar}) {
  
  
  const classes = classNames(
    'utility-bar',
    'u-cursor-pointer',
    modifierClasses
  )

  const handleClickInternal = () => {
    setUtilityBar(!showUtilityBar)
    handleClick()
  }

  return (
    <div 
      className={classes} 
      aria-haspopup="true"
      aria-expanded={showUtilityBar}
      onClick={handleClickInternal}>
      {children}
    </div>
  )
}

export default UtilityBar
